// src/schedule/FreeDayRow.js
import React, { useState, useRef, useEffect } from 'react';
import PortalDropdown from './PortalDropdown';
import Avatar from './Avatar';

const weekdayNames = ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'Sb'];

const FreeDayRow = ({ date, todayStr, employees, unavailable, toggleUnavailable, isExpanded = false }) => {
    const [showUnavailableMenu, setShowUnavailableMenu] = useState(false);
    const btnRef = useRef(null);

    const hasAnyUnavailable = (unavailable?.length || 0) > 0;

    useEffect(() => {
        if (!showUnavailableMenu) return;
        const onResize = () => setShowUnavailableMenu(false);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [showUnavailableMenu]);

    // 🔧 DZISIAJ: porównuj string do stringa (bez UTC)
    const isToday = String(date) === String(todayStr);

    const d = new Date(date);
    const dayNumber = d.getDate();
    const weekday = weekdayNames[d.getDay()];

    // W trybie expanded wyświetl tylko centralnie ikonę
    if (isExpanded) {
        return (
            <div
                id={`day-${date}`}
                data-day-anchor={date}
                className="free-day-expanded flex items-center justify-center h-full w-full"
            >
                <span className="text-8xl">🏖️</span>
            </div>
        );
    }

    return (
<div
  id={`day-${date}`}                // 🔧 kotwica do auto-scrolla
  data-day-anchor={date}
  className={`free-day freedayrow flex items-center justify-between gap-3 my-1 p-2 rounded ${isToday ? 'freedayrow--today' : ''}`}
  // 🔧 „podkreślenie na pomarańczowo" – border na całym wierszu (Tailwind amber-400)
  title={isToday ? 'Dziś: dzień wolny' : undefined}
>
  <div className="flex items-center gap-3">
    <span className="text-2xl">🏖️</span>
                <span className={`font-semibold ${isToday ? 'text-white-200 decoration-orange-400 decoration-2 underline-offset-[3px]' : ''}`}>
      {dayNumber} ({weekday})
    </span>
  </div>

            <div>
                <button
                    ref={btnRef}
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowUnavailableMenu(prev => !prev);
                    }}
                    className="cursor-pointer relative"
                    aria-expanded={showUnavailableMenu}
                    title="Zarządzaj nieobecnościami"
                >
                    📋
                    {hasAnyUnavailable && (
                        <span className="absolute -inset-1 border-2 border-red-500 rounded pointer-events-none"></span>
                    )}
                </button>

                <PortalDropdown
                    anchorRef={btnRef}
                    open={showUnavailableMenu}
                    onClose={() => setShowUnavailableMenu(false)}
                    align="right"
                    width={260}
                    maxHeight={360}
                >
                    <div className="p-2">
                        {(employees || []).map((emp, idx) => {
                            const empName = typeof emp === 'string' ? emp : emp?.name;
                            const isUnavailable = (unavailable || []).some(u => {
                                const uName = typeof u === 'string' ? u : u?.name;
                                return uName === empName;
                            });
                            return (
                                <div
                                    key={idx}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleUnavailable(empName);
                                    }}
                                    className={`px-2 py-2 cursor-pointer flex items-center gap-2 ${isUnavailable ? 'bg-red-700 text-white' : 'hover:bg-gray-600'}`}
                                >
                                    <Avatar employee={emp} size={20} />
                                    <span>{empName}</span>
                                </div>
                            );
                        })}
                        {!employees?.length && (
                            <div className="text-sm text-gray-400 px-2 py-1">Brak pracowników</div>
                        )}
                    </div>
                </PortalDropdown>
            </div>
        </div>
    );
};

export default FreeDayRow;
